import React from 'react';
import {
  AppBar,
  Grid,
  makeStyles,
  Tab,
  Tabs,
  Theme,
  Drawer,
  Container,
} from '@material-ui/core';
import { IoIosCloseCircleOutline } from 'react-icons/io';

import { useGrupoPizza } from '../../../../../../hooks/grupoPizza';

import pizza_icon from '../../../../../../assets/pizza_icon.svg';

import { AddNewGroup, CloseButton, DrawerTitle, DrawerContainer } from '../../drawer_styles';
import TabPanel from '../../../../../Configuracoes/TabBar/TabPanel';

import Detalhes from './tabs/Detalhes';
import Tamanhos from './tabs/Tamanhos';
import Complementos from './tabs/Complementos';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const GrupoPizza: React.FC = () => {
  const {
    complementosIsEnabled,
    tamanhosIsEnabled,
    currentTabIndex,
    drawerIsOpen,
    openDrawer,
    resetDrawer,
    changeCurrentTabIndex,
  } = useGrupoPizza();

  const classes = useStyles();

  return (
    <>
      <AddNewGroup onClick={openDrawer}>
        <img src={pizza_icon} alt="Grupo Pizza" />
        <div>
          <p>Grupo Pizza</p>
          <span>Selecione massa, bordas e sabores.</span>
        </div>
      </AddNewGroup>

      <Drawer anchor="right" open={drawerIsOpen} onClose={resetDrawer}>
        <CloseButton onClick={resetDrawer} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation">
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle>
                <h1>Grupo Pizza</h1>
              </DrawerTitle>
            </Grid>

            <Grid>
              <AppBar
                position="static"
                color="transparent"
                className={classes.noShadow}
              >
                <Tabs
                  value={currentTabIndex}
                  onChange={(_event, tabIndex) => changeCurrentTabIndex(tabIndex)}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="grupo_pizza_tabs"
                  className={classes.tabBorder}
                >
                  <Tab label="Detalhes" {...a11yProps(0)} />
                  <Tab
                    label="Tamanhos"
                    disabled={!tamanhosIsEnabled}
                    {...a11yProps(1)}
                  />
                  <Tab
                    label="Complementos"
                    disabled={!complementosIsEnabled}
                    {...a11yProps(2)}
                  />
                </Tabs>
              </AppBar>
              <TabPanel value={currentTabIndex} index={0} >
                <Detalhes />
              </TabPanel>
              <TabPanel value={currentTabIndex} index={1}>
                <Tamanhos />
              </TabPanel>
              <TabPanel value={currentTabIndex} index={2}>
                <Complementos />
              </TabPanel>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default GrupoPizza;
